export const UserRoleEnum = {
	Admin: 1,
	Plant: 2,
    Client: 3
}